import React, { useCallback, useEffect, useRef, useState } from 'react';
import MarkdownText from '../../../MarkdownText/MarkdownText';
import Eyebrow from '../../../Eyebrow/Eyebrow';
import Image from '../../../Image/Image';
import Button from '../../../Button/Button';
import throttle from 'lodash/throttle';
import Icon from '../../../Icon/Icon';
import DotNav from '../../../DotNav/DotNav';
import Modal from 'react-modal';
import { customJsonstringify, isObjectEmpty, toggleScroll, customSuperJsonParse } from '../../../../adapters/helpers/Utils';
import { WarrantyExtensionConstants } from '../../../../adapters/helpers/Constants';
import { removeProductFromDisplayedList, removeProductFromJanrainList } from './../../helpers/product.helpers';
import Label from '../../../Label/Label';
import { deleteIsCreatingAccountFromLocalStorage, getJanrainCaptureProfileDataFromLocalStorage } from '../../helpers/localstorage.helpers';
import { postReplaceEntityUpdate } from '../../../../adapters/model/service/api/svc';
import { getPostReplaceEntityObject } from '../../../../adapters/model/service/api/svc';
import { postWarrantyRegistrationUpdate } from '../../../../adapters/model/service/warrantyExtension/warrantyExtension.helpers';
import ResponsiveImage from '../../../ResponsiveImage/ResponsiveImage';
import { optimizeImage } from '../../../../adapters/helpers/pagespeedHelper';
import Link from 'next/link';
import DOMPurify from "isomorphic-dompurify";
const ProductManagement = ({
  oralbProductList,
  profileProductManagementTab,
  commonLabels,
  customStyles,
  closeModalTimeoutMS,
  setOralbProductList,
  isGCSAPIDown
}) => {
  var _profileProductManage, _profileProductManage2, _profileProductManage3, _profileProductManage4, _profileProductManage5, _profileProductManage6, _profileProductManage7, _profileProductManage8, _profileProductManage9, _profileProductManage10, _profileProductManage11, _profileProductManage12, _profileProductManage13, _profileProductManage14, _profileProductManage15, _profileProductManage16, _profileProductManage17, _profileProductManage18, _profileProductManage19, _profileProductManage20, _profileProductManage21, _profileProductManage22, _profileProductManage23, _profileProductManage24, _profileProductManage25, _janrainLabels$regist, _janrainLabels$regist2, _janrainLabels$regist3, _janrainLabels$regist4, _janrainLabels$regist5, _janrainLabels$regist6, _janrainLabels$downlo, _janrainLabels$downlo2, _janrainLabels$downlo3, _janrainLabels$downlo4, _janrainLabels$downlo5, _janrainLabels$downlo6, _janrainLabels$downlo7, _janrainLabels$downlo8, _currentProduct$cmsPr, _currentProduct$cmsPr2;
  const [currentPage, setCurrentPage] = useState(0);
  const [numCarouselPages, setNumCarouselPages] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [lastScroll, setLastScroll] = useState(0);
  const [requestedProduct, setRequestedProduct] = useState({});
  const [currentProduct, setCurrentProduct] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [isProgress, setIsProgress] = useState(false);
  const productCarouselRef = useRef(null);
  const dotNavRef = useRef(null);
  const viewWarrantyLink = profileProductManagementTab == null ? void 0 : (_profileProductManage = profileProductManagementTab.viewWarrantyLink) == null ? void 0 : _profileProductManage.fields;
  const registeredProductLimit = profileProductManagementTab == null ? void 0 : profileProductManagementTab.registeredProductLimit;
  const dummyImage = profileProductManagementTab == null ? void 0 : profileProductManagementTab.dummyImage;
  const janrainLabels = {
    title: profileProductManagementTab == null ? void 0 : profileProductManagementTab.title,
    profileIntroText: profileProductManagementTab == null ? void 0 : profileProductManagementTab.profileIntroText,
    productManagementText: profileProductManagementTab == null ? void 0 : profileProductManagementTab.productManagementText,
    primaryButtonLabel: profileProductManagementTab == null ? void 0 : (_profileProductManage2 = profileProductManagementTab.primaryButtonLabel) == null ? void 0 : (_profileProductManage3 = _profileProductManage2.fields) == null ? void 0 : _profileProductManage3.text,
    makePrimaryButtonLabel: profileProductManagementTab == null ? void 0 : (_profileProductManage4 = profileProductManagementTab.makePrimaryButtonLabel) == null ? void 0 : (_profileProductManage5 = _profileProductManage4.fields) == null ? void 0 : _profileProductManage5.text,
    deleteLabel: profileProductManagementTab == null ? void 0 : (_profileProductManage6 = profileProductManagementTab.delete) == null ? void 0 : (_profileProductManage7 = _profileProductManage6.fields) == null ? void 0 : _profileProductManage7.text,
    registeredOn: profileProductManagementTab == null ? void 0 : (_profileProductManage8 = profileProductManagementTab.registeredOn) == null ? void 0 : (_profileProductManage9 = _profileProductManage8.fields) == null ? void 0 : _profileProductManage9.text,
    registerProductLinkGwe: profileProductManagementTab == null ? void 0 : profileProductManagementTab.registerProductLinkGwe,
    tryTheAppTitle: profileProductManagementTab == null ? void 0 : profileProductManagementTab.tryTheAppTitle,
    tryTheAppText: profileProductManagementTab == null ? void 0 : profileProductManagementTab.tryTheAppText,
    downloadOnAppStore: profileProductManagementTab == null ? void 0 : profileProductManagementTab.downloadOnAppStore,
    downloadOnPlayStore: profileProductManagementTab == null ? void 0 : profileProductManagementTab.downloadOnPlayStore,
    productManagementModalTitle: profileProductManagementTab == null ? void 0 : (_profileProductManage10 = profileProductManagementTab.productManagementModalTitle) == null ? void 0 : (_profileProductManage11 = _profileProductManage10.fields) == null ? void 0 : _profileProductManage11.text,
    deleteProductModalTitle: profileProductManagementTab == null ? void 0 : (_profileProductManage12 = profileProductManagementTab.deleteProductModalTitle) == null ? void 0 : (_profileProductManage13 = _profileProductManage12.fields) == null ? void 0 : _profileProductManage13.text,
    productManagementModalSubtitle: profileProductManagementTab == null ? void 0 : (_profileProductManage14 = profileProductManagementTab.productManagementModalSubtitle) == null ? void 0 : (_profileProductManage15 = _profileProductManage14.fields) == null ? void 0 : _profileProductManage15.text,
    productManagementModalConfirm: profileProductManagementTab == null ? void 0 : (_profileProductManage16 = profileProductManagementTab.productManagementModalConfirm) == null ? void 0 : (_profileProductManage17 = _profileProductManage16.fields) == null ? void 0 : _profileProductManage17.text,
    registeredProductLimitLabel: profileProductManagementTab == null ? void 0 : (_profileProductManage18 = profileProductManagementTab.registeredProductLimitLabel) == null ? void 0 : (_profileProductManage19 = _profileProductManage18.fields) == null ? void 0 : _profileProductManage19.text,
    gcsDownErrorMessage: profileProductManagementTab == null ? void 0 : (_profileProductManage20 = profileProductManagementTab.gcsDownErrorMessage) == null ? void 0 : (_profileProductManage21 = _profileProductManage20.fields) == null ? void 0 : _profileProductManage21.text,
    previousLabel: profileProductManagementTab == null ? void 0 : (_profileProductManage22 = profileProductManagementTab.previousLabel) == null ? void 0 : (_profileProductManage23 = _profileProductManage22.fields) == null ? void 0 : _profileProductManage23.text,
    nextLabel: profileProductManagementTab == null ? void 0 : (_profileProductManage24 = profileProductManagementTab.nextLabel) == null ? void 0 : (_profileProductManage25 = _profileProductManage24.fields) == null ? void 0 : _profileProductManage25.text,
    ...commonLabels
  };
  const commonControlBtnIconProps = {
    name: 'thinChevronDown',
    size: 2.4
  };
  const updateNumCarouselPages = () => {
    if (window && (productCarouselRef == null ? void 0 : productCarouselRef.current)) {
      const carousel = productCarouselRef.current;
      const children = carousel.children;
      let fullCarouselWidth = 0;
      for (let i = 0; i < children.length; i++) {
        const element = children[i];
        let elementWidth = element.offsetWidth;
        const style = getComputedStyle(element);
        elementWidth += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
        fullCarouselWidth += elementWidth;
      }
      // This fixes an issue where the result of "fullCarouselWidth / carousel.offsetWidth" was a low decimal point
      // and created less carousel pages than expected
      if ((oralbProductList == null ? void 0 : oralbProductList.length) % 3 === 1) {
        setNumCarouselPages(Math.ceil(fullCarouselWidth / carousel.offsetWidth));
      } else {
        setNumCarouselPages(Math.round(fullCarouselWidth / carousel.offsetWidth));
      }
    }
  };
  useEffect(() => {
    const handleResize = throttle(updateNumCarouselPages, 100);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });
  useEffect(() => {
    updateNumCarouselPages();
  }, []);
  useEffect(() => {
    if (!isObjectEmpty(oralbProductList)) {
      const product = oralbProductList.find(e => e.isPrimary);
      setCurrentProduct(product);
    }
    if (document.querySelector('.js-modal-container')) {
      Modal.setAppElement('.js-modal-container');
    }
  }, []);
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScroll]);
  useEffect(() => {
    toggleScroll(isModalOpen, lastScroll);
  }, [isModalOpen]);
  useEffect(() => {
    closeModal();
    updateNumCarouselPages();
  }, [oralbProductList]);
  const onScroll = useCallback(event => {
    if (!productCarouselRef.current) {
      return;
    }
    const currentRatio = event.target.scrollLeft / productCarouselRef.current.clientWidth;
    const min = Math.floor(currentRatio);
    let currentPosition = currentRatio < min + 0.3 ? min : min + 1;
    currentPosition = Math.max(0, currentPosition);
    currentPosition = Math.min(oralbProductList.length, currentPosition);
    setCurrentPage(currentPosition);
  }, [productCarouselRef.current]);
  const handleDotClick = useCallback(i => {
    if (productCarouselRef.current) {
      const nextY = productCarouselRef.current.clientWidth * i;
      if (productCarouselRef.current.scrollTo) {
        productCarouselRef.current.scrollTo({
          left: nextY,
          behavior: 'smooth'
        });
      } else {
        productCarouselRef.current.scrollLeft = nextY;
      }
    }
  }, []);
  const handleClick = event => {
    if ((dotNavRef == null ? void 0 : dotNavRef.current) && (productCarouselRef == null ? void 0 : productCarouselRef.current)) {
      let activePageIndex = parseInt(dotNavRef.current.querySelector('.ob-dot-nav__item--active .ob-dot-nav__button').dataset.index, 10);
      const clickedButton = event.currentTarget.dataset.controlButton;
      if (clickedButton === 'next' && activePageIndex + 1 < numCarouselPages) {
        activePageIndex = activePageIndex + 1;
      } else if (clickedButton === 'prev' && activePageIndex - 1 >= 0) {
        activePageIndex = activePageIndex - 1;
      }
      const nextY = productCarouselRef.current.clientWidth * activePageIndex;
      if (productCarouselRef.current.scrollTo) {
        productCarouselRef.current.scrollTo({
          left: nextY,
          behavior: 'smooth'
        });
      } else {
        productCarouselRef.current.scrollLeft = nextY;
      }
    }
  };
  const handleScroll = useCallback(() => {
    if (!document.body.classList.contains('noScroll')) {
      setLastScroll(window.pageYOffset);
    }
  });
  const closeModal = () => {
    setIsModalOpen(false);

    // Needed so the state only updates once the modal is closed and not during
    setTimeout(() => {
      setRequestedProduct({});
      setIsDeleting(false);
    }, closeModalTimeoutMS);
  };
  const openModal = event => {
    event.preventDefault();
    const product = customSuperJsonParse(event.currentTarget.dataset.custom);
    setRequestedProduct(product);
    setIsModalOpen(true);
  };
  const deleteItem = () => {
    setIsProgress(true);
    const janrainProfileData = customSuperJsonParse(getJanrainCaptureProfileDataFromLocalStorage());
    const newLocalStorageProductList = removeProductFromJanrainList(janrainProfileData.traitProductType, requestedProduct.id, requestedProduct.orderProductId);
    const newDisplayedProductList = removeProductFromDisplayedList(oralbProductList, requestedProduct.id, requestedProduct.orderProductId);
    // remove id from localStorage product. /entity.replace doesn't accept them. A new id will be generated.
    newLocalStorageProductList.forEach(product => {
      delete product.id;
    });
    let postObject = getPostReplaceEntityObject(janrainProfileData);
    postObject['traitProductType'] = newLocalStorageProductList;

    //remove primary product attributes
    if (requestedProduct == null ? void 0 : requestedProduct.isPrimary) {
      if (Array.isArray(newDisplayedProductList) && newDisplayedProductList.length > 0) {
        const oldestProductIndex = WarrantyExtensionConstants.janrinProfileOldestProductIndex;
        const oldestProduct = newDisplayedProductList[oldestProductIndex];
        const primaryProductSku = oldestProduct.productId;
        postObject['primaryProduct'] = primaryProductSku + '_' + oldestProduct.purchaseDate;
        const traitPrimaryBrushValue = {
          traitValue: null,
          productTypeCode: oldestProduct.typeCode
        };
        postObject['traitPrimaryBrush'] = traitPrimaryBrushValue;
        postWarrantyRegistrationUpdate(oldestProduct, janrainProfileData, true, false);
        newDisplayedProductList[oldestProductIndex].isPrimary = true;
      } else {
        postObject['primaryProduct'] = '';
        postObject['traitPrimaryBrush'] = {};
      }
    }
    const postReplaceSuccess = () => {
      setIsProgress(false);
    };
    // GCS post, callback janrain entity update on success
    postWarrantyRegistrationUpdate(requestedProduct, janrainProfileData, false, true, postReplaceEntityUpdate, function () {}, postObject, postReplaceSuccess);
    setOralbProductList(newDisplayedProductList);
  };
  const makePrimary = () => {
    setIsProgress(true);
    const janrainProfileData = customSuperJsonParse(getJanrainCaptureProfileDataFromLocalStorage());
    let postObject = getPostReplaceEntityObject(janrainProfileData);
    const primaryProductSku = requestedProduct.productId;
    postObject['primaryProduct'] = primaryProductSku + '_' + requestedProduct.purchaseDate;
    const traitPrimaryBrushValue = {
      traitValue: null,
      productTypeCode: requestedProduct.typeCode
    };
    postObject['traitPrimaryBrush'] = traitPrimaryBrushValue;
    const postReplaceSuccess = () => {
      setIsProgress(false);
    };
    postWarrantyRegistrationUpdate(requestedProduct, janrainProfileData, true, false, postReplaceEntityUpdate, function () {}, postObject, postReplaceSuccess);
    const newProductList = [];
    let primarySet = false;
    for (let i = 0; i < oralbProductList.length; i++) {
      const product = oralbProductList[i];
      if (!primarySet && product.productId === requestedProduct.productId && product.orderProductId === requestedProduct.orderProductId && product.id === requestedProduct.id) {
        product.isPrimary = true;
        primarySet = true;
      } else {
        product.isPrimary = false;
      }
      newProductList.push(product);
    }
    setOralbProductList(newProductList);
  };
  return <div className={'ob-product-management js-modal-container'}>
            <MarkdownText className={'ob-product-management__text'} value={janrainLabels.profileIntroText} />
            <Eyebrow className={'ob-product-management__title'}>{janrainLabels.title}</Eyebrow>
            <MarkdownText className={'ob-product-management__text'} value={janrainLabels.productManagementText} />
            {isProgress && <div className='ob-product-management__spinner'></div>}
            {!isObjectEmpty(oralbProductList) && <div className={'ob-product-management__carousel'}>
                    <ul className={`ob-product-management__product-list ${numCarouselPages === 1 || oralbProductList.length === 1 ? 'is-centered' : ''}`} onScroll={onScroll} ref={productCarouselRef}>
                        {oralbProductList.map((product, index) => {
          var _viewWarrantyLink$pag, _viewWarrantyLink$pag2;
          return <li className={'ob-product-management__product-list-item'} key={index}>
                                <div>
                                    <div className={'ob-product-management__product-image-wrapper'}>
                                        {(product == null ? void 0 : product.imageUrl) ? <img src={optimizeImage(product == null ? void 0 : product.imageUrl)} alt={(product == null ? void 0 : product.name) || ''} className={'ob-product-management__product-image'} fetchPriority="high" /> : <ResponsiveImage document={dummyImage} />}
                                    </div>
                                    <p className={'ob-product-management__product-title'} dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(product == null ? void 0 : product.title)
              }}></p>
                                </div>
                                <div>
                                    <Button className={'ob-product-management__product-date'} textTheme={true} tag={'a'} href={`${viewWarrantyLink == null ? void 0 : (_viewWarrantyLink$pag = viewWarrantyLink.pagePath) == null ? void 0 : (_viewWarrantyLink$pag2 = _viewWarrantyLink$pag.fields) == null ? void 0 : _viewWarrantyLink$pag2.slug}?product_id=${product == null ? void 0 : product.id}`}>
                                        {janrainLabels.registeredOn + ' ' + (product == null ? void 0 : product.traitDate)}
                                    </Button>
                                    <div className={'ob-product-management__product-buttons-container'}>
                                        {product.isPrimary ? <span data-size={'small-slim'} className={'ob-button ob-product-management__product-button --is-primary'}>
                                                {janrainLabels.primaryButtonLabel}
                                            </span> : <Button size={'small-slim'} borderThemeBlue={true} className={'ob-product-management__product-button ob-product-management__make-primary-btn'} dataCustom={customJsonstringify(product)} disabled={isProgress} onClick={openModal}>
                                                {janrainLabels.makePrimaryButtonLabel}
                                            </Button>}
                                        <Button textTheme={true} dataCustom={customJsonstringify(product)} onClick={e => {
                  setIsDeleting(true);
                  openModal(e);
                }} disabled={isProgress} className={'ob-product-management__product-button'}>
                                            {janrainLabels.deleteLabel}
                                        </Button>
                                    </div>
                                </div>
                            </li>;
        })}
                    </ul>

                    {numCarouselPages > 1 && <div>
                            <button className={'ob-product-management__carousel--control-button'} data-control-button={'prev'} aria-label={janrainLabels == null ? void 0 : janrainLabels.previousLabel} onClick={handleClick} disabled={currentPage === 0} type={'button'}>
                                <span>
                                    <Icon {...commonControlBtnIconProps} rotate={90} />
                                </span>
                            </button>
                            <button className={'ob-product-management__carousel--control-button'} data-control-button={'next'} aria-label={janrainLabels == null ? void 0 : janrainLabels.nextLabel} onClick={handleClick} disabled={currentPage === numCarouselPages - 1} type={'button'}>
                                <span>
                                    <Icon {...commonControlBtnIconProps} rotate={-90} />
                                </span>
                            </button>
                            <div ref={dotNavRef}>
                                <DotNav count={numCarouselPages} onClick={handleDotClick} current={currentPage} color={'blue'} />
                            </div>
                        </div>}
                </div>}
            {!isGCSAPIDown && <div className={'ob-product-management__add-product-container'}>
                    {!isObjectEmpty(oralbProductList) && oralbProductList.length >= registeredProductLimit ? <>
                            <Button size={'large-long'} tag={'button'} disabled={true} className={'ob-profile__full-width-btn'}>
                                {(_janrainLabels$regist = janrainLabels.registerProductLinkGwe) == null ? void 0 : (_janrainLabels$regist2 = _janrainLabels$regist.fields) == null ? void 0 : _janrainLabels$regist2.title}
                            </Button>
                            <span className={'ob-product-management__product-limit-label'}>{janrainLabels.registeredProductLimitLabel}</span>
                        </> : <Button size={'large-long'} tag={'a'} href={(_janrainLabels$regist3 = janrainLabels.registerProductLinkGwe) == null ? void 0 : (_janrainLabels$regist4 = _janrainLabels$regist3.fields) == null ? void 0 : _janrainLabels$regist4.url} className={'ob-profile__full-width-btn'} onClick={deleteIsCreatingAccountFromLocalStorage}>
                            {(_janrainLabels$regist5 = janrainLabels.registerProductLinkGwe) == null ? void 0 : (_janrainLabels$regist6 = _janrainLabels$regist5.fields) == null ? void 0 : _janrainLabels$regist6.title}
                        </Button>}
                </div>}

            {isGCSAPIDown && <p className={'ob-input__error'}>{janrainLabels.gcsDownErrorMessage}</p>}

            <div className={'ob-product-management__app-container'}>
                <Eyebrow className={'ob-product-management__app-title'}>{janrainLabels.tryTheAppTitle}</Eyebrow>
                <MarkdownText className={'ob-product-management__text'} value={janrainLabels.tryTheAppText} />
                <ul className={'ob-product-management__app-list'}>
                    <li>
                        <Link className={'ob-product-management__app-link'} href={(_janrainLabels$downlo = janrainLabels.downloadOnAppStore) == null ? void 0 : (_janrainLabels$downlo2 = _janrainLabels$downlo.fields) == null ? void 0 : _janrainLabels$downlo2.url} target='_blank' rel='noopener noreferrer'>
                            <Image className={'ob-product-management__app-img'} image={(_janrainLabels$downlo3 = janrainLabels.downloadOnAppStore) == null ? void 0 : (_janrainLabels$downlo4 = _janrainLabels$downlo3.fields) == null ? void 0 : _janrainLabels$downlo4.image} />
                        </Link>
                    </li>
                    <li>
                        <Link className={'ob-product-management__app-link'} href={(_janrainLabels$downlo5 = janrainLabels.downloadOnPlayStore) == null ? void 0 : (_janrainLabels$downlo6 = _janrainLabels$downlo5.fields) == null ? void 0 : _janrainLabels$downlo6.url} target='_blank' rel='noopener noreferrer'>
                            <Image className={'ob-product-management__app-img'} image={(_janrainLabels$downlo7 = janrainLabels.downloadOnPlayStore) == null ? void 0 : (_janrainLabels$downlo8 = _janrainLabels$downlo7.fields) == null ? void 0 : _janrainLabels$downlo8.image} />
                        </Link>
                    </li>
                </ul>
            </div>

            <Modal isOpen={isModalOpen} onRequestClose={closeModal} closeTimeoutMS={closeModalTimeoutMS} style={customStyles} htmlOpenClassName={'ob-profile__modal-overlay'}>
                <div className={'ob-profile__modal-container'}>
                    <div>
                        <p className={'ob-profile__modal-title'}>
                            {isDeleting ? <Label label={janrainLabels.deleteProductModalTitle} tokens={{
              productName: requestedProduct == null ? void 0 : requestedProduct.title
            }} /> : <Label label={janrainLabels.productManagementModalTitle} tokens={{
              productName: requestedProduct == null ? void 0 : requestedProduct.title
            }} />}
                        </p>
                        {!isDeleting && (currentProduct == null ? void 0 : (_currentProduct$cmsPr = currentProduct.cmsProductInfo) == null ? void 0 : _currentProduct$cmsPr.title) && <p className={'ob-profile__modal-subtitle'}>
                                <Label label={janrainLabels.productManagementModalSubtitle} tokens={{
              productName: currentProduct == null ? void 0 : (_currentProduct$cmsPr2 = currentProduct.cmsProductInfo) == null ? void 0 : _currentProduct$cmsPr2.title
            }} />
                            </p>}
                    </div>
                    <div>
                        <Button className={'ob-profile__modal-confirm-btn'} size={'large-long'} onClick={isDeleting ? deleteItem : makePrimary}>
                            {janrainLabels.productManagementModalConfirm}
                        </Button>
                        <Button textTheme={true} className={'ob-profile__modal-cancel-btn'} onClick={closeModal}>
                            {janrainLabels.modalCancelButton}
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>;
};
export default ProductManagement;